<template>
  <div class="notice-lists">
    <div class="bot" v-if="tabCode != 19 && tabCode != 22">
      <div class="tyy">
        <div class="search_condition search_one">
          <div style="margin-right: 10px">
            <span class="label_title">方案编号：</span>
            <el-input
              v-model.trim="formData.schemeCode"
              clearable
              style="width: 150px"
              placeholder="请输入方案编号查询"
            ></el-input>
          </div>
          <div style="margin-right: 10px">
            <span class="label_title">方案/公告名称：</span>
            <el-input
              v-model.trim="formData.schemeName"
              clearable
              style="width: 150px"
              placeholder="请输入方案/公告名称查询"
            ></el-input>
          </div>
          <div style="margin-right: 10px">
            <span class="label_title">采购方式：</span>
            <el-select
              v-model.trim="formData.purchaseType"
              style="width: 150px"
              clearable
              placeholder="请选择采购方式查询"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search_condition search_one">
          <div style="margin-right: 10px">
            <span class="label_title">采购组织单位：</span>
            <el-select
              ref="orgNameSelectTree"
              v-model.trim="formData.purchaseUnitName"
              clearable
              @clear="clear"
              style="width: 150px"
              popper-class="orgNameSelectTree"
              placeholder="请选择采购组织单位查询"
            >
              <el-option value="1">
                <el-tree
                  ref="tree"
                  :props="treeProps"
                  :load="loadNode"
                  node-key="id"
                  lazy
                  @node-click="onSubmitSingle"
                >
                </el-tree>
              </el-option>
            </el-select>
          </div>
          <div style="margin-right: 10px">
            <span class="label_title">施工城市：</span>
            <el-cascader
              ref="cas"
              style="width: 150px"
              v-model="formData.provinceCode"
              clearable
              :props="locationList"
              placeholder="请选择施工城市查询"
              @change="handleChange"
            >
            </el-cascader>
          </div>
          <!-- <div style="margin-right: 10px">
            <span class="label_title">工程类别：</span>
            <el-select
              v-model.trim="formData.engineerType"
              clearable
              style="width: 150px"
              placeholder="请选择工程类别查询"
              @change="handleEngineerTypeChange"
            >
              <el-option
                v-for="item in workCategory"
                :key="item.subjectCode"
                :label="item.subjectName"
                :value="item.subjectCode"
              ></el-option>
            </el-select>
          </div> -->
          <div style="margin-right: 10px">
            <span class="label_title">包件类型：</span>
            <el-input
              v-model.trim="formData.subjectName"
              clearable
              @clear="clearProfess"
              @focus="openTypeDialog"
              style="width: 150px"
              placeholder="请选择包件类型查询"
            ></el-input>
          </div>
        </div>
        <div class="search_condition search_two">
          <div style="margin-right: 10px">
            <span class="label_title">发布时间：</span>
            <el-select
              v-model.trim="formData.timeFlag"
              clearable
              style="width: 150px"
              placeholder="请选择发布时间查询"
            >
              <el-option label="今天" value="4"></el-option>
              <el-option label="近三天" value="1"></el-option>
              <el-option label="近一周" value="2"></el-option>
              <el-option label="近一月" value="3"></el-option>
            </el-select>
          </div>
          <div style="margin-right: 10px">
            <span class="label_title">分包类型：</span>
            <el-select
              v-model.trim="formData.schemeClass"
              clearable
              style="width: 150px"
              placeholder="请选择发布时间查询"
            >
              <el-option
                v-for="item in schemeClass"
                :key="item.dicKey"
                :label="item.dicValue"
                :value="item.dicKey"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="tyo">
        <el-button type="primary" @click="search" icon="el-icon-search"
          >搜索</el-button
        >
      </div>
    </div>
    <div
      class="ccui-multifunctional-table-wrapper"
      v-if="tabCode != 19 && tabCode != 22"
    >
      <el-table
        :data="inventoryTableDatas"
        height="416"
        v-loading="loading"
        border
        :fit="true"
      >
        <el-table-column label="序号" width="45" align="center" fixed>
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(table, index) in tableHeadOptions"
          :fixed="table.fixed || false"
          :key="index"
          :type="table.type"
          :label="table.label"
          :min-width="table.minWidth"
          :width="table.width"
          :prop="table.prop"
          :align="table.align || 'left'"
          :header-align="table.headerAlign || 'left'"
          :filters="table.filters"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            <span
              @click="handleViewDetail(row)"
              class="tyt"
              v-if="table.slot === 'schemeCode'"
              >{{ row[table.prop] }}</span
            >
            <span v-else-if="table.slot === 'noticeStartTime'">{{
              noticeStartTime(row[table.prop])
            }}</span>
            <span
              style="display: flex; align-items: center"
              v-else-if="table.slot === 'isLianyu'"
            >
              <span>{{ row[table.prop] == 1 ? "是" : "否" }}</span>

              <img
                v-if="row.isNew == 1"
                :src="gif"
                style="width: 36px; margin-left: 5px; height: 18px"
              />
            </span>
            <span v-else>{{ row[table.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="ccui-multifunctional-table-wrapper" v-if="tabCode == 19">
      <list
        :isIndex="true"
        ref="lists"
        :currBreadCrumb="currBreadCrumb"
        :callInterface="callInterface"
        :otherParams="otherParams"
      ></list>
    </div>

    <div class="ccui-multifunctional-table-wrapper" v-if="tabCode == 22">
      <div style="padding: 20px">
        <div>
          <h2 style="padding: 10px 0 30px 0; border-bottom: 1px solid #ccc">
            联系我们
          </h2>
        </div>
        <div>
          <div style="font-size: 14px; margin: 25px 0px">
            <span style="width: 100px; display: inline-block; text-align: right"
              >电话：</span
            >
            400-676-5885
          </div>
          <div style="font-size: 14px">
            <span style="width: 100px; display: inline-block; text-align: right"
              >咨询时间：</span
            >8:30-11:30，13:30-17:30（法定节假日除外）
          </div>
        </div>
      </div>
    </div>

    <div
      class="table-footer"
      v-if="tabCode != 19 && tabCode != 22"
      style="height: 35px; margin-top: 10px; padding: 0 10px"
    >
      <div class="ccui-table-footer">
        <div class="ccui-left">共 {{ inventoryTotal }} 条</div>
        <div id="ccui-paging">
          <el-pagination
            :total="inventoryTotal"
            :page-size="inventoryPageSize"
            :current-page="inventoryPageNoCode"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout=" total, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @current-change="inventoryHandleCurrentChange"
          />
        </div>
      </div>
    </div>

    <ProfessionalCategorySingle
      ref="professionDialog"
      @getProfessions="getProfessions"
      :listSubconBaseSubjectList="professionList"
    ></ProfessionalCategorySingle>
  </div>
</template>

<script>
import {
  queryScpSchemeNoticeListByNoLogin,
  queryPublishedNoticeList,
  qryOmcOrgTree,
  selectFirstLevelSubjectCode,
  listDictByCode,
  selectSubjectNewList,
  getCountryList,
  getAdministrationList,
} from "@/app/shop/api/shopping";
// import globalCofig from "@/setting/setting";
import list from "@/app/shop/components/list.vue";
import ProfessionalCategorySingle from "@/app/shop/components/packType.vue";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import Cookies from "js-cookie";
import moment from "moment";
import gif from "@/config/assets/images/1.gif";

export default {
  name: "noticeList",
  components: {
    list,
    ProfessionalCategorySingle,
  },
  mixins: [mixinHomePage],
  props: {
    supCode: {
      type: String,
      default: "",
    },
    encSupCode: {
      type: String,
      default: "",
    },
    supName: {
      type: String,
      default: "",
    },
    tabCode: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      gif: gif,
      professionList: [],
      loading: false,
      lock: false,
      currBreadCrumb: [{ title: this.$t("page.content.Announcements") }],
      callInterface: queryPublishedNoticeList,
      otherParams: {
        agentId: 100131,
        module: 1,
        pageState: 2,
        appId: 100131,
      },
      options: [],
      inventoryTotal: 0,
      inventoryPageSize: 10,
      formData: {
        schemeCode: "",
        schemeName: "",
        purchaseType: "",
        purchaseUnitCode: "",
        purchaseUnitName: "",
        provinceCode: "",
        engineerType: "",
        schemeClass: "",
        subjectCodes: "",
        subjectName: "",
        timeFlag: "",
      },
      formDatas: {},
      inventoryPageNoCode: 1,
      inventoryTableDatas: [],
      tableHeadOptions: [
        {
          label: "采购编号",
          fixed: "left",
          slot: "schemeCode",
          prop: "schemeCode",
          minWidth: 180,
        },
        { label: "方案名称", prop: "schemeName", minWidth: 200 },
        { label: "公告名称", prop: "noticeTitle", minWidth: 180 },
        { label: "采购方式", prop: "purchaseTypeName", minWidth: 90 },
        {
          label: "发布时间",
          slot: "noticeStartTime",
          prop: "noticeStartTime",
          minWidth: 160,
        },
        // { label: "报名截止时间", prop: "time", minWidth: 120 },
      ],
      tableHeadOptionsNew1: [
        {
          label: "采购编号",
          fixed: "left",
          slot: "schemeCode",
          prop: "schemeCode",
          minWidth: 180,
        },
        { label: "方案名称", prop: "schemeName", minWidth: 200 },
        { label: "公告名称", prop: "noticeTitle", minWidth: 180 },
        { label: "公告类型", prop: "purStepStr", minWidth: 180 },
        { label: "采购方式", prop: "purchaseTypeName", minWidth: 90 },
        {
          label: "发布时间",
          slot: "noticeStartTime",
          prop: "noticeStartTime",
          minWidth: 160,
        },
        // { label: "报名截止时间", prop: "time", minWidth: 120 },
      ],
      tableHeadOptionsNew3: [
        {
          label: "采购编号",
          fixed: "left",
          slot: "schemeCode",
          prop: "schemeCode",
          minWidth: 180,
        },
        { label: "方案名称", prop: "schemeName", minWidth: 200 },
        { label: "公告名称", prop: "noticeTitle", minWidth: 180 },
        {
          label: "随机短信通知分包商中标",
          prop: "isLianyu",
          slot: "isLianyu",
          minWidth: 180,
        },
        { label: "初始入库单位", prop: "initUnitName", minWidth: 180 },
        { label: "公告类型", prop: "purStepStr", minWidth: 180 },
        { label: "采购方式", prop: "purchaseTypeName", minWidth: 90 },
        {
          label: "发布时间",
          slot: "noticeStartTime",
          prop: "noticeStartTime",
          minWidth: 160,
        },
        // { label: "报名截止时间", prop: "time", minWidth: 120 },
      ],
      tableHeadOptionsNew2: [
        {
          label: "采购编号",
          fixed: "left",
          slot: "schemeCode",
          prop: "schemeCode",
          minWidth: 180,
        },
        { label: "方案名称", prop: "schemeName", minWidth: 200 },
        { label: "公告名称", prop: "noticeTitle", minWidth: 180 },
        { label: "采购方式", prop: "purchaseTypeName", minWidth: 90 },
        {
          label: "发布时间",
          slot: "noticeStartTime",
          prop: "noticeStartTime",
          minWidth: 160,
        },
        // { label: "报名截止时间", prop: "time", minWidth: 120 },
      ],
      moment: moment,
      loginInfo: this.$store.state.user.loginInfo || {},
      supOrPur: "",
      orgTypes: 0,
      treeData: [],
      node: null,
      partyId: 100002, //单位采购的父级Id
      treeProps: {
        label: "orgFullName",
        children: "child",
        isLeaf: "isLeaf",
      },
      workCategory: [], //工程类别
      schemeClass: [],
      subjectCodes: "",
      subjectName: "",
      // 施工城市选择下拉框
      locationList: {
        label: "zcountryname",
        value: "zcountrycode",
        lazy: true,
        expandTrigger: "hover",
        checkStrictly: true,
        lazyLoad(node, resolve) {
          console.log(node, "ssssaaaa");
          const { level } = node;
          if (level == 0) {
            getCountryList({
              zcountryname: "中国",
              pageNo: 1,
              pageSize: 1000,
            })
              .then((res) => {
                if (!Array.isArray(res.data.data)) {
                  res.data.data = res.data.data.rows;
                }
                let result = res.data.data;
                resolve(result);
              })
              .catch(() => {});
          } else if (level == 1) {
            getAdministrationList({
              zaddvsup: "0",
              pageNo: 1,
              pageSize: 1000,
            })
              .then((res) => {
                if (!Array.isArray(res.data.data)) {
                  res.data.data = res.data.data.rows;
                }
                let result = res.data.data.map((item) => {
                  item.zcountryname = item.zaddvsname;
                  item.zcountrycode = item.zaddvscode;
                  return item;
                });
                resolve(result);
              })
              .catch(() => {});
          }
        },
      },
    };
  },
  mounted() {},
  activated() {
    this.init();
    if (this.$store.getters.getAccessToken) {
      this.options = [
        { label: this.$t("page.content.all"), value: "" },
        { label: this.$t("page.content.publicBidding"), value: "0" },
        {
          label: this.$t("page.content.invitationTender"),
          value: "3",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1",
        },
        {
          label: "邀请谈判",
          value: "4",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1",
        },
        {
          label: "邀请询比",
          value: "1",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1",
        },
        { label: "公开询比", value: "7" },
        { label: "公开谈判", value: "8" },
      ];
    } else {
      this.options = [
        { label: this.$t("page.content.all"), value: "" },
        { label: this.$t("page.content.publicBidding"), value: "0" },
        { label: this.$t("page.content.publicBiddingXb"), value: "7" },
        { label: "公开谈判", value: "8" },
        // {
        //   label: this.$t("page.content.competitiveNegotiation"),
        //   value: "3",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1",
        // },
        // {
        //   label: this.$t("page.content.invitationTender"),
        //   value: "4",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1",
        // },
      ];
    }
  },
  methods: {
    noticeStartTime(val) {
      return val ? val.substr(0, 16) : "";
    },
    openTypeDialog() {
      this.$refs.professionDialog.centerDialogVisible2 = true;
    },

    clearProfess() {
      this.formData.subjectCodes = [];
      this.formData.subjectName = "";
    },

    init() {
      if (
        this.supInfo.getSupInfoByLoginInfoRspBOList &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        this.supOrPur = "sup";
      } else {
        this.supOrPur = "pur";
      }
      this.getNoticeList({
        noticeType: 3,
        supCode:
          this.supInfo.getSupInfoByLoginInfoRspBOList &&
          this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
            ? this.supInfo.getSupInfoByLoginInfoRspBOList[0].supCode
            : "",
        encSupCode:
          this.supInfo.getSupInfoByLoginInfoRspBOList &&
          this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
            ? this.supInfo.getSupInfoByLoginInfoRspBOList[0].encSupCode
            : "",
      });
      this.getDictData();
      this.selectSubjectNewList();
    },

    // 搜索
    search() {
      console.log(this.formData);
      Object.assign(this.formDatas, this.formData);
      // this.formDatas = JSON.parse(JSON.stringify(this.formData));
      // 每次点击搜索重置页码
      this.inventoryPageNoCode = 1;
      delete this.formDatas.engineerType;
      this.getNoticeList();
    },
    // 选择采购组织单位
    onSubmitSingle(data, node) {
      this.node = node;
      console.log(data, node, "data, node");
      this.formData.purchaseUnitCode = data.autoCode;
      this.formData.purchaseUnitName = data.name;
    },

    getProfessions(keys, names) {
      this.formData.subjectCodes = keys;
      this.formData.subjectName = names;
    },

    selectSubjectNewList(type) {
      selectSubjectNewList({
        subjectCode: type,
        isSelectThreeLevel: 0,
      }).then(
        // queryProfessionList({ subjectCode: type, isSelectThreeLevel: "0" }).then(
        (res) => {
          if (res.data.code === "0") {
            localStorage.setItem("ywlb", JSON.stringify(res.data.data));
          }
        }
      );
    },

    //获取采购组织单位树
    // 树接口
    loadNode(node, resolve) {
      if (node.level === 0) {
        qryOmcOrgTree({
          orgId: 100002,
          flag: this.orgTypes,
          parentId: this.partyId,
        }).then((res) => {
          this.data = res.data.data;
          return resolve(res.data.data);
        });
      }

      if (node.level > 1) {
        qryOmcOrgTree({
          orgId: 100002,
          parentId: node.data.partyId,
          flag: this.orgTypes,
        }).then((res) => {
          resolve(res.data.data[0].child);
        });
      }

      if (node.level === 1) {
        let that = this;
        setTimeout(() => {
          let data = [];
          data = that.data[0].child;
          resolve(data);
        }, 500);
      }
    },
    //
    clear() {
      this.formData.purchaseUnitCode = "";
      this.formData.purchaseUnitName = "";
    },
    handleChange(data) {
      if (data) {
        this.formData.provinceCode = data[1] ? data[1] : "";
      }
    },
    handleEngineerTypeChange(data) {
      console.log(data, 1111, "1111");
      if (!data) {
        console.log(data, 2222, "2222");
        this.formData.engineerTypes = [];
        return;
      } else {
        this.formData.engineerTypes = [data];
      }
    },
    // 工程类别
    getDictData() {
      // 工程类别
      selectFirstLevelSubjectCode({
        code: "WORK_CATEGORY",
      })
        .then((res) => {
          this.workCategory = Object.freeze(res.data.data);
        })
        .catch((error) => {});
      listDictByCode({
        code: "SUBCONTRACT_TYPE",
      })
        .then((res) => {
          this.schemeClass = Object.freeze(res.data.data);
        })
        .catch((error) => {});
    },
    handleViewDetail(row) {
      if (this.tabCode == 3 || this.tabCode == 4 || this.tabCode == 5) {
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetail",
          query: {
            type: this.tabCode,
            schemeId: row.schemeId,
            noticeId: row.noticeId,
            supCode: row.supCode || this.supCode || "",
          },
        });
        window.open(url.href, "_blank");
      } else {
        // this.handleView(row);
        if (row.isJoin === 0 || row.isJoin === "0") {
          // 未参与
          this.handleView(row);
        } else {
          // 已参与
          // window.open(
          //   this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          //     "?CLIENT_ID=" +
          //     globalCofig.agentId +
          //     "&CALLBACK_URL=" +
          //     encodeURIComponent(
          //       `${this.$addUrlPerFix(
          //         process.env.VUE_APP_BID_URL
          //       )}/shop/participateSub?schemeId=${row.schemeId}&purchaseType=${
          //         row.purchaseType
          //       }&noticeStartTime=${
          //         row.noticeStartTime
          //       }&schemeName=${encodeURIComponent(
          //         row.schemeName
          //       )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
          //         this.supCode || row.supCode
          //       }&supName=${this.supName}&a=${globalCofig.agentId}`
          //     ),
          //   "_blank"
          // );
          window.open(
            this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
              "?CLIENT_ID=" +
              JSON.parse(localStorage.usedSupInfo)?.secretAgentId +
              "&CALLBACK_URL=" +
              encodeURIComponent(
                `${this.$addUrlPerFix(
                  process.env.VUE_APP_CRMSA_URL
                )}/bid/bidFlowIndexSub?schemeId=${
                  row.schemeId
                }&noticeStartTime=${new Date(
                  row.noticeStartTime
                ).getTime()}&noticeEndTime=${row.noticeEndTime}&schemeName=${
                  row.schemeName
                }&schemeCode=${row.schemeCode}${
                  this.supCode || row.supCode
                    ? "&supCode=" + (this.supCode || row.supCode)
                    : ""
                }&supName=${encodeURIComponent(row.supName)}&purchaseType=${
                  row.purchaseType
                }&supplierFlag=1&a=${
                  JSON.parse(localStorage.usedSupInfo)?.secretAgentId
                }`
              )
          );
        }
      }
    },

    inventoryHandleCurrentChange(val) {
      this.inventoryPageNoCode = val;
      this.getNoticeList();
    },

    getNoticeList(obj) {
      if (this.tabCode == 22) {
        return false;
      }
      console.log(this.lock, "-");
      console.log(this.supInfo, "this.supInfo");
      if (this.lock) return;
      this.lock = true;
      let supCodeList = [];
      let encSupCodeList = [];
      if (this.supInfo && this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(
          (item) => {
            return item.supCode;
          }
        );
        encSupCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(
          (item) => {
            return item.encSupCode;
          }
        );
      }
      let params = {
        pageNo: this.inventoryPageNoCode,
        pageSize: this.inventoryPageSize,
        // isShowLoading: true,
        tabId: this.tabCode,
        ...this.formDatas,
      };
      if (this.supCode) {
        params.supCode = this.supCode;
        params.encSupCode = this.encSupCode;
        params.isLogin = 1;
      } else if (obj && obj.supCode) {
        params.supCode = obj.supCode;
        params.encSupCode = obj.encSupCode;
        params.isLogin = 1;
      } else if (supCodeList.length > 0) {
        params.supCode = supCodeList[0];
        params.encSupCode = encSupCodeList[0];
        params.isLogin = 1;
      } else {
        params.isLogin = 0;
      }
      // if (
      //   Cookies.get("language") !== undefined &&
      //   Cookies.get("language") !== "zh-cn"
      // ) {
      //   params.overseasSupFlag = 1;
      // }
      // Object.assign(params, obj);
      // debugger
      // if (!params.supCode) {
      //   return false;
      // }
      this.loading = true;
      queryScpSchemeNoticeListByNoLogin(params)
        .then((res) => {
          console.log("列表接口 ");
          this.loading = false;
          this.lock = false;
          if (res.data.code === "0") {
            if (res.data.data.rows) {
              this.inventoryTableDatas = res.data.data.rows || [];
              this.inventoryTotal = res.data.data.recordsTotal; //总条数
            }
          }
        })
        .catch((err) => {
          this.lock = false;
        });
    },
    isLogin() {
      if (Cookies.get("access_token")) {
        return true;
      } else {
        this.$message({
          message: this.$t("page.content.loginTip"),
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 21,
        });
        return false;
      }
    },

    queryPublishedNoticeList() {
      queryPublishedNoticeList({
        agentId: 100131,
        pageNo: 1,
        pageSize: 10,
        module: 1,
        pageState: 2,
        appId: 100131,
      }).then((res) => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.rows;
        }
      });
    },

    refList() {
      this.inventoryTotal = 0;
      this.inventoryPageSize = 10;
      this.inventoryPageNoCode = 1;
      this.inventoryTableDatas = [];
      if (this.tabCode == 19) {
        // this.queryPublishedNoticeList();
        this.$nextTick(() => {
          this.$refs.lists.getNoticeList();
        });
      } else {
        this.getNoticeList();
      }
    },
  },
  computed: {
    showNoticeTitle() {
      return (item) => {
        if (item.supName) {
          return `[${item.supName}]${item.noticeTitle}`;
        } else {
          return item.noticeTitle;
        }
      };
    },
    supInfo() {
      return this.$store.state.user.supInfo || {};
    },
  },
  watch: {
    supCode(val) {
      // 切换了单位，重新请求接口列表
      this.refList();
    },
    tabCode(val) {
      // 切换了tab，请求列表
      this.formDatas = {
        schemeCode: "",
        schemeName: "",
        purchaseType: "",
        purchaseUnitName: "",
        purchaseUnitCode: "",
        provinceCode: "",
        engineerTypes: [],
      };
      this.formData = {
        schemeCode: "",
        schemeName: "",
        purchaseType: "",
        purchaseUnitName: "",
        provinceCode: "",
        schemeClass: "",
        engineerType: "",
        timeFlag: "",
      };
      if (val == 3) {
        this.tableHeadOptions = this.tableHeadOptionsNew1;
      } else if (val == 5) {
        this.tableHeadOptions = this.tableHeadOptionsNew3;
      } else {
        this.tableHeadOptions = this.tableHeadOptionsNew2;
      }
      this.refList();
    },
  },
};
</script>
<style>
#arktitle {
  /* font-size: 14px; */
  /*line-height: 280px;*/
  margin-left: 5px;
  background: red;
  -webkit-background-clip: text;
  color: transparent;
  animation: blink 2s infinite;
  -webkit-animation: blink 2s infinite;
  -moz-animation: blink 2s infinite;
  -ms-animation: blink 2s infinite;
  -o-animation: blink 2s infinite;
  text-align: center;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  /* 50% {
    opacity: 0.5;
  } */
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  /* 50% {
    opacity: 0.5;
  } */
  100% {
    opacity: 0;
  }
}
@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  /* 50% {
    opacity: 0.5;
  } */
  100% {
    opacity: 0;
  }
}
@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  /* 50% {
    opacity: 0.5;
  } */
  100% {
    opacity: 0;
  }
}
@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  /* 50% {
    opacity: 0.5;
  } */
  100% {
    opacity: 0;
  }
}
</style>

<style scoped lang="scss">
.tyt {
  color: #0089ef;
  cursor: pointer;
}
.bot {
  display: flex;
  align-items: center;
  padding: 10px;
  .tyy {
    font-size: 14px;
    display: flex;
    flex-direction: column;

    // width: 910px;
    .search_condition {
      display: flex;
      align-items: center;
      span {
        flex: 1;
      }
      div {
        display: flex;
        align-items: center;
      }
    }
    .search_one {
      margin-bottom: 10px;
    }
  }
  .tyo {
    flex: 1;
  }
}
.notice-lists {
  height: 600px;
  width: 910px;
  background: #ffffff;
  position: relative;
  .notice-list-tabs {
    padding: 20px 15px 0;
    .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #eeeaea;
    }
    .el-tabs__item {
      font-size: 14px;
      height: 28px;
      line-height: 24px;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
  }
  .notice-list-view-all {
    position: absolute;
    right: 15px;
    top: 14px;
    line-height: 24px;
  }
  .notice-list-group {
    padding-top: 8px;
    a {
      padding-top: 12px;
      display: block;
      cursor: pointer;
      font-size: 13px;
      line-height: 18px;
      color: #4a4a4a;
      font-weight: 500;
      float: left;
      text-align: right;
      span {
        color: #999999;
        width: 79px;
        float: left;
        &:hover {
          color: #0089ef;
        }
      }
      .ellipsis {
        float: left;
        display: block;
        width: 466px;
        text-align: left;
        color: #4a4a4a;
      }
      &:nth-child(2n) {
        margin-left: 40px;
      }
    }
  }

  //.flex-row-between {
  //  display: flex;
  //  flex-direction: row;
  //  flex-wrap: wrap;
  //  justify-content: space-between;
  //}
  //.justify-space-between {
  //  font-size: 13px;
  //  color: #4a4a4a;
  //  font-weight: 500;
  //  display: flex;
  //  justify-content: space-between;
  //}
}
.mt20 {
  margin-top: 20px;
}
.ccui-left {
  float: left;
  font-size: 12px;
  color: #666;
  font-weight: 400;
  margin: 1px 5px 0 8px;
}
// 采购组织单位下拉框
.orgNameSelectTree {
  /deep/.el-select-dropdown__item.selected,
  .el-select-dropdown__item {
    box-sizing: content-box;
    font-size: 13px;
    padding: 0 !important;
    margin-right: 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #4a4a4a;
    height: 100% !important;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
}
.label_title {
  width: 110px;
  text-align: right;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 20px;
}
</style>
